export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/position/base_count',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/basis/position',
      method: 'POST'
    },
    {
      path: '/basis/org/all',
      method: 'GET'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/basis/position/{id}',
      method: 'PUT'
    },
    {
      path: '/basis/org/all',
      method: 'GET'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/basis/position/{id}',
      method: 'DELETE'
    }]
  }
}